import React, { useState, useEffect, useMemo } from "react";
import { MdCalendarToday, MdHome, MdArrowDropDown, MdOutlineAccessTime } from "react-icons/md";
import Widget from "components/widget/Widget";
import RelatorioTrafego from "views/admin/reports/components/RelatoriosTrafego";
import MetaDiariaPorUnidade from "views/admin/reports/components/RelatorioMetasUnidades";
import { useUnidades } from "context/UnidadeContext";
import { useRelatorios } from "context/RelatorioContext";
import RelatorioMetas from "views/admin/reports/components/RelatorioMetas";
import RelatorioUnidades from "views/admin/reports/components/RelatorioUnidades";
import RelatorioPessoas from "views/admin/reports/components/RelatorioPessoas";
import RelatorioPesquisa from "views/admin/reports/components/RelatorioPesquisa";
import Modal from "components/modal/Modal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDevices } from "context/DeviceContext";
import { useAprendizado } from "context/AprendizadoContext";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "services/firebase";
// import { db, functions, storage } from "services/firebase";
// import { httpsCallable } from "firebase/functions";
// import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import * as XLSX from 'xlsx';
import { useAuth } from "context/AuthContext";

export default function Dashboard() {
  const { user } = useAuth();
  const { unidades } = useUnidades();
  const { relatorios } = useRelatorios();
  const { devices } = useDevices();
  const { aprendizadoData } = useAprendizado();
  const [displayDate, setDisplayDate] = useState("Carregando...");
  const [selectedDate, setSelectedDate] = useState<string>("");
  const [selectedUnidadeId, setSelectedUnidadeId] = useState<string | "Todas">("Todas");
  const [selectedPeriodo, setSelectedPeriodo] = useState<string>("Todos");
  const [showExportModal, setShowExportModal] = useState(false);
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null]);
  const [startDate, endDate] = dateRange;
  const [selectedUnidadesExport, setSelectedUnidadesExport] = useState<string[]>([]);
  const [fileType, setFileType] = useState<".xlsx" | ".xls" | ".csv">(".xlsx");
  const [isExporting, setIsExporting] = useState(false);
  const [isSending] = useState(false);
  // const [isSending, setIsSending] = useState(false);
  // const [emailParaEnvio] = useState("");

  const todosOsExpedientes = useMemo(() => {
    const expedientesSet = new Set<string>();
    devices.forEach(device => {
      if (device.expedientes) {
        Object.keys(device.expedientes).forEach(titulo => {
          expedientesSet.add(titulo);
        });
      }
    });
    return Array.from(expedientesSet).sort();
  }, [devices]);

  useEffect(() => {
    if (relatorios && relatorios.length > 0) {
      const datasDisponiveis = [...new Set(relatorios.map(r => r.Data))].sort((a, b) => b.localeCompare(a));
      const dataMaisRecente = datasDisponiveis[0];

      if (dataMaisRecente) {
        setSelectedDate(dataMaisRecente);

        const [y, m, d] = dataMaisRecente.split("-");
        setDisplayDate(`${d}/${m}/${y}`);
      }
    } else {
      setDisplayDate("Vazio");
    }
  }, [relatorios]);

  const gerarWorkbook = async () => {
    if (!user?.uid) {
      alert("Usuário não autenticado.");
      return null;
    }
    if (!startDate || !endDate || selectedUnidadesExport.length === 0) {
      alert("Por favor, selecione um intervalo de datas e pelo menos uma unidade.");
      return null;
    }

    const dadosRelatorio = gerarDadosRelatorioPrincipal();
    const dadosHorarios = gerarDadosHorarios();
    const dadosAprendizado = gerarDadosAprendizado();
    const dadosPessoas = gerarDadosPessoas();
    const dadosSolicitacoes = await gerarDadosSolicitacoes();
    const dadosPesquisa = gerarDadosPesquisa();
    const dadosSobraLimpa = gerarDadosSobraLimpa();

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(dadosRelatorio), "Relatório");
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(dadosHorarios), "Horarios");
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(dadosAprendizado), "Aprendizado");
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(dadosPessoas), "Pessoas");
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(dadosSolicitacoes), "Solicitações");
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(dadosPesquisa), "Pesquisa");
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(dadosSobraLimpa), "SobraLimpa");

    return wb;
  };

  const handleExport = async () => {
    setIsExporting(true);
    try {
      const wb = await gerarWorkbook();
      if (wb) {
        XLSX.writeFile(wb, `Relatorio_ControlFood${fileType}`);
      }
    } catch (error) {
      console.error("Erro ao gerar o relatório:", error);
      alert("Ocorreu um erro ao gerar o relatório.");
    } finally {
      setIsExporting(false);
      if (startDate && endDate && selectedUnidadesExport.length > 0) {
        setShowExportModal(false);
      }
    }
  };

  // const handleSendEmail = async () => {
  //   if (!user?.uid) {
  //     alert("Usuário não autenticado.");
  //     return;
  //   }
  //   if (!emailParaEnvio) {
  //     alert("Por favor, preencha o e-mail do destinatário.");
  //     return;
  //   }
  //   if (!startDate || !endDate || selectedUnidadesExport.length === 0) {
  //     alert("Por favor, selecione um intervalo de datas e pelo menos uma unidade.");
  //     return;
  //   }

  //   setIsSending(true);

  //   try {
  //     const wb = await gerarWorkbook();
  //     if (!wb) {
  //       setIsSending(false);
  //       return;
  //     }

  //     const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  //     const blob = new Blob([wbout], { type: "application/octet-stream" });
  //     const fileName = `Relatorio_ControlFood_${Date.now()}.xlsx`;
  //     const storageRef = ref(storage, `clientes/${user.uid}/relatorios-exportados/${fileName}`);
  //     await uploadBytes(storageRef, blob);
  //     const downloadURL = await getDownloadURL(storageRef);
  //     const emailSubject = `Relatório ControlFood: ${startDate?.toLocaleDateString('pt-BR')} - ${endDate?.toLocaleDateString('pt-BR')}`;

  //     const emailBody = `
  //       <p>👋 Olá,</p>
  //       <p>O relatório solicitado do sistema ControlFood foi gerado com sucesso. 🚀</p>
  //       <p><strong>Período:</strong> ${startDate?.toLocaleDateString('pt-BR')} a ${endDate?.toLocaleDateString('pt-BR')}</p>
  //       <p>👇 Clique no botão abaixo para fazer o download do arquivo.</p>

  //       <a href="${downloadURL}" 
  //          style="background-color: #CF4949; color: white; padding: 12px 20px; text-align: center; text-decoration: none; display: inline-block; border-radius: 8px; font-weight: bold;">
  //          Baixar Relatório
  //       </a>

  //       <p>Atenciosamente, Equipe ControlFood 🍽️🤖</p>
  //     `;

  //     const sendEmailFunction = httpsCallable(functions, 'sendReportByEmail');
  //     await sendEmailFunction({
  //       to: emailParaEnvio,
  //       subject: emailSubject,
  //       html: emailBody,
  //     });

  //     alert(`Relatório enviado com sucesso para ${emailParaEnvio}`);

  //   } catch (error) {
  //     console.error("Erro ao gerar ou enviar o relatório:", error);
  //     alert("Ocorreu um erro ao processar sua solicitação. Verifique o console para mais detalhes.");
  //   } finally {
  //     setIsSending(false);
  //     setShowExportModal(false);
  //   }
  // };

  const gerarDadosRelatorioPrincipal = () => {
    const unidadesSelecionadas = unidades.filter(u => selectedUnidadesExport.includes(u.id));
    const dispositivoIdsSelecionados = unidadesSelecionadas.map(u => u.dispositivoId);
    if (!startDate || !endDate) return [];
    const adjustedEndDate = new Date(endDate);
    adjustedEndDate.setHours(23, 59, 59, 999);
    const relatoriosFiltrados = relatorios.filter(r => {
      const matchUnidade = dispositivoIdsSelecionados.includes(r.dispositivoId);
      if (!matchUnidade) return false;
      const dataRelatorio = new Date(r.Data + "T00:00:00");
      return dataRelatorio >= startDate && dataRelatorio <= adjustedEndDate;
    });

    return relatoriosFiltrados.map(r => {
      const nomeUnidade = unidades.find(u => u.dispositivoId === r.dispositivoId)?.nome || "Desconhecida";
      return {
        "Unidade": nomeUnidade,
        "Dia": r.DiaSemana,
        "Data": new Date(r.Data + "T12:00:00").toLocaleDateString('pt-BR'),
        "Expediente": r.expediente,
        "Contagem": r.contador,
      };
    });
  };

  const gerarDadosHorarios = () => {
    const unidadesSelecionadas = unidades.filter(u => selectedUnidadesExport.includes(u.id));
    const dadosFormatados: any[] = [];

    unidadesSelecionadas.forEach(unidade => {
      const device = devices.find(d => d.id === unidade.dispositivoId);
      if (!device || !device.expedientes) return;

      Object.entries(device.expedientes).forEach(([titulo, horario]) => {
        dadosFormatados.push({
          "Unidade": device.name,
          "Dias de Operação": device.days.join(', '),
          "Expediente": titulo,
          "Horário": `${horario.start} - ${horario.end}`,
        });
      });
    });
    return dadosFormatados;
  };

  const gerarDadosAprendizado = () => {
    const unidadesSelecionadas = unidades.filter(u => selectedUnidadesExport.includes(u.id));
    const dadosFormatados: any[] = [];
    unidadesSelecionadas.forEach(unidade => {
      const aprendizado = aprendizadoData.find(a => a.dispositivoId === unidade.dispositivoId);
      if (!aprendizado) return;
      const dataInicio = new Date(aprendizado.dataCadastro);
      const dataFim = new Date(dataInicio);
      dataFim.setDate(dataInicio.getDate() + 28);
      const relatoriosAprendizado = relatorios.filter(r => {
        const dataRelatorio = new Date(r.Data);
        return r.dispositivoId === unidade.dispositivoId && dataRelatorio >= dataInicio && dataRelatorio <= dataFim;
      });
      relatoriosAprendizado.forEach(r => {
        dadosFormatados.push({
          "Unidade": unidade.nome,
          "Dia": r.DiaSemana,
          "Data": new Date(r.Data + "T12:00:00").toLocaleDateString('pt-BR'),
          "Expediente": r.expediente,
          "Contagem": r.contador,
        });
      });
    });
    return dadosFormatados;
  };

  const gerarDadosPessoas = () => {
    const unidadesSelecionadas = unidades.filter(u => selectedUnidadesExport.includes(u.id));
    const dispositivoIdsSelecionados = unidadesSelecionadas.map(u => u.dispositivoId);
    if (!startDate || !endDate) return [];
    const adjustedEndDate = new Date(endDate);
    adjustedEndDate.setHours(23, 59, 59, 999);
    const dadosFormatados: any[] = [];

    const relatoriosFiltrados = relatorios.filter(r => {
      const matchUnidade = dispositivoIdsSelecionados.includes(r.dispositivoId);
      const dataRelatorio = new Date(r.Data + "T00:00:00");
      return matchUnidade && dataRelatorio >= startDate && dataRelatorio <= adjustedEndDate;
    });

    relatoriosFiltrados.forEach(r => {
      if (r.pessoasDoDia && Array.isArray(r.pessoasDoDia)) {
        r.pessoasDoDia.forEach((pessoa: any) => {
          const dataHora = new Date(pessoa.dataHoraPessoas);
          dadosFormatados.push({
            "Foto": { t: 's', v: 'Ver Foto', l: { Target: pessoa.fotoUrl, Tooltip: 'Clique para abrir a imagem' } },
            "Data": dataHora.toLocaleDateString('pt-BR'),
            "Hora": dataHora.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }),
          });
        });
      }
    });
    return dadosFormatados;
  };

  const gerarDadosSolicitacoes = async () => {
    if (!user?.uid || !startDate || !endDate) return [];
    const unidadesSelecionadas = unidades.filter(u => selectedUnidadesExport.includes(u.id));
    const dispositivoIds = unidadesSelecionadas.map(u => u.dispositivoId);
    if (dispositivoIds.length === 0) return [];

    const q = query(
      collection(db, `clientes/${user.uid}/solicitacoes`),
      where("dispositivoId", "in", dispositivoIds),
      where("Data", ">=", startDate.toISOString().split('T')[0]),
      where("Data", "<=", endDate.toISOString().split('T')[0])
    );
    const snapshot = await getDocs(q);
    const solicitacoes = snapshot.docs.map(doc => doc.data());
    return solicitacoes.map(s => {
      const unidadeNome = unidades.find(u => u.dispositivoId === s.dispositivoId)?.nome || "Desconhecida";
      return {
        "Unidade": unidadeNome,
        "Produto": s.Produto,
        "Data": new Date(s.Data + "T12:00:00").toLocaleDateString('pt-BR'),
        "Hora": s.Hora,
        "Status": s.Status,
      };
    });
  };

  const gerarDadosPesquisa = () => {
    const unidadesSelecionadas = unidades.filter(u => selectedUnidadesExport.includes(u.id));
    const dispositivoIdsSelecionados = unidadesSelecionadas.map(u => u.dispositivoId);
    if (!startDate || !endDate) return [];

    const adjustedEndDate = new Date(endDate);
    adjustedEndDate.setHours(23, 59, 59, 999);

    const dadosFormatados: any[] = [];

    const relatoriosFiltrados = relatorios.filter(r => {
      const matchUnidade = dispositivoIdsSelecionados.includes(r.dispositivoId);
      const dataRelatorio = new Date(r.Data + "T00:00:00");
      return matchUnidade && dataRelatorio >= startDate && dataRelatorio <= adjustedEndDate;
    });

    relatoriosFiltrados.forEach(r => {
      if (r.pesquisa) {
        const nomeUnidade = unidades.find(u => u.dispositivoId === r.dispositivoId)?.nome || "Desconhecida";
        const titulo = r.pesquisa.titulo || "Sem Título";
        const dataFormatada = new Date(r.Data + "T12:00:00").toLocaleDateString('pt-BR');

        let avaliacoesObj: Record<string, number> = {};

        if (r.pesquisa.avaliacoes && typeof r.pesquisa.avaliacoes === 'object') {
          avaliacoesObj = r.pesquisa.avaliacoes;
        }
        else {
          Object.entries(r.pesquisa).forEach(([key, value]) => {
            if (key.startsWith('avaliacoes.')) {
              const criterio = key.replace('avaliacoes.', '');
              avaliacoesObj[criterio] = Number(value);
            }
          });
        }

        Object.entries(avaliacoesObj).forEach(([criterio, valor]) => {
          dadosFormatados.push({
            "Unidade": nomeUnidade,
            "Dia": r.DiaSemana,
            "Data": dataFormatada,
            "Expediente": r.expediente,
            "Titulo": titulo,
            "Critério": criterio,
            "Avaliação": valor
          });
        });
      }
    });

    if (dadosFormatados.length === 0) {
      return [{ "Unidade": "", "Dia": "", "Data": "", "Expediente": "", "Titulo": "", "Critério": "", "Avaliação": "" }];
    }

    return dadosFormatados;
  };

  const gerarDadosSobraLimpa = () => {
    const unidadesSelecionadas = unidades.filter(u => selectedUnidadesExport.includes(u.id));
    const dispositivoIdsSelecionados = unidadesSelecionadas.map(u => u.dispositivoId);
    if (!startDate || !endDate) return [];

    const adjustedEndDate = new Date(endDate);
    adjustedEndDate.setHours(23, 59, 59, 999);

    const dadosFormatados: any[] = [];

    const relatoriosFiltrados = relatorios.filter(r => {
      const matchUnidade = dispositivoIdsSelecionados.includes(r.dispositivoId);
      const dataRelatorio = new Date(r.Data + "T00:00:00");
      return matchUnidade && dataRelatorio >= startDate && dataRelatorio <= adjustedEndDate;
    });

    relatoriosFiltrados.forEach(r => {
      if (r.sobraLimpa) {
        const nomeUnidade = unidades.find(u => u.dispositivoId === r.dispositivoId)?.nome || "Desconhecida";
        const dataFormatada = new Date(r.Data + "T12:00:00").toLocaleDateString('pt-BR');

        Object.entries(r.sobraLimpa).forEach(([nomeCuba, dadosCuba]: [string, any]) => {
          dadosFormatados.push({
            "Unidade": nomeUnidade,
            "Dia": r.DiaSemana,
            "Data": dataFormatada,
            "Expediente": r.expediente,
            "Nome": nomeCuba,
            "Descrição": dadosCuba.descricao || "",
            "Status": dadosCuba.status || "",
            "Peso(g)": dadosCuba.peso || 0,
            "Percentual": dadosCuba.percentual || "",
            "Justificativa": dadosCuba.justificativa || ""
          });
        });
      }
    });

    if (dadosFormatados.length === 0) {
      return [{ "Unidade": "", "Dia": "", "Data": "", "Expediente": "", "Nome": "", "Descrição": "", "Status": "", "Peso(g)": "", "Percentual": "", "Justificativa": "" }];
    }

    return dadosFormatados;
  };

  // const filtrados = relatorios.filter(r => {
  //   const matchDate = r.Data === selectedDate;
  //   const matchUnidade = selectedUnidadeId === "Todas" || r.dispositivoId === selectedUnidadeId;
  //   const matchPeriodo = selectedPeriodo === "Todos" || r.expediente === selectedPeriodo;
  //   return matchDate && matchUnidade && matchPeriodo;
  // });

  // const totalHoje = filtrados.reduce((sum, r) => sum + (r.contador || 0), 0);

  return (
    <div className="relative min-h-screen">
      <div className="mt-3 grid gap-5 xl:grid-cols-5">

        <Widget
          icon={<MdCalendarToday className="h-6 w-6 text-[#B84343]" />}
          title="Data"
          subtitle={displayDate}
          extra={
            <div className="relative h-8 w-8">
              <MdArrowDropDown className="pointer-events-none absolute inset-0 h-full w-full text-gray-500" />
              <select
                className="absolute inset-0 h-full w-full cursor-pointer opacity-0"
                value={selectedDate}
                onChange={e => {
                  setSelectedDate(e.target.value);
                  const [y, m, d] = e.target.value.split("-");
                  setDisplayDate(`${d}/${m}/${y}`);
                }}
              >
                {[...new Set(relatorios.map(r => r.Data))].sort((a, b) => b.localeCompare(a)).map(dt => (
                  <option key={dt} value={dt}>
                    {(() => { const [y, m, d] = dt.split("-"); return `${d}/${m}/${y}`; })()}
                  </option>
                ))}
              </select>
            </div>
          }
        />

        <Widget
          icon={<MdHome className="h-6 w-6 text-[#B84343]" />}
          title="Unidade"
          subtitle={selectedUnidadeId === "Todas" ? "Todas" : unidades.find(u => u.dispositivoId === selectedUnidadeId)?.nome || "Todas"}
          extra={
            <div className="relative h-8 w-8">
              <MdArrowDropDown className="pointer-events-none absolute inset-0 h-full w-full text-gray-500" />
              <select
                className="absolute inset-0 h-full w-full cursor-pointer opacity-0"
                value={selectedUnidadeId}
                onChange={e => setSelectedUnidadeId(e.target.value)}
              >
                <option value="Todas">Todas</option>
                {unidades.map(u => (<option key={u.id} value={u.dispositivoId}>{u.nome}</option>))}
              </select>
            </div>
          }
        />

        <Widget
          icon={<MdOutlineAccessTime className="h-6 w-6 text-[#B84343]" />}
          title="Período"
          subtitle={selectedPeriodo}
          extra={
            <div className="relative h-8 w-8">
              <MdArrowDropDown className="pointer-events-none absolute inset-0 h-full w-full text-gray-500" />
              <select
                className="absolute inset-0 h-full w-full cursor-pointer opacity-0"
                value={selectedPeriodo}
                onChange={e => setSelectedPeriodo(e.target.value)}
              >
                <option value="Todos">Todos</option>
                {todosOsExpedientes.map(expediente => (
                  <option key={expediente} value={expediente}>
                    {expediente}
                  </option>
                ))}
              </select>
            </div>
          }
        />

        {/* <Widget
          icon={<MdPeople className="h-6 w-6 text-[#B84343]" />}
          title="Total"
          subtitle={`${totalHoje} Pessoas`}
        />  */}

      </div>

      <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-3">
        <MetaDiariaPorUnidade
          selectedDate={selectedDate}
          selectedPeriodo={selectedPeriodo}
          selectedUnidadeId={selectedUnidadeId}
        />
        <RelatorioTrafego selectedPeriodo={selectedPeriodo} />
        <RelatorioUnidades selectedUnidadeId={selectedUnidadeId} />
      </div>

      <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-2">
        <RelatorioPesquisa
          selectedDate={selectedDate}
          selectedUnidadeId={selectedUnidadeId}
          selectedPeriodo={selectedPeriodo}
        />
        <RelatorioMetas />
      </div>

      <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-1">
        <RelatorioPessoas selectedUnidadeId={selectedUnidadeId} />
      </div>

      <button
        onClick={() => setShowExportModal(true)}
        className="fixed bottom-8 right-8 z-30 rounded-lg bg-[#CF4949] px-4 py-2 font-bold text-white shadow-lg transition duration-200 hover:bg-[#B84343] active:bg-[#B84343]"
      >
        Exportar Relatório
      </button>

      {showExportModal && (
        <Modal onClose={() => setShowExportModal(false)}>
          <h2 className="text-xl font-bold mb-6 text-center">EXPORTAR RELATÓRIO</h2>

          <div className="mb-4">
            <label className="block font-medium mb-1">Selecione a Data:</label>
            <div className="flex flex-col rounded max-h-40 overflow-y-auto">
              <DatePicker
                selectsRange={true}
                startDate={startDate}
                endDate={endDate}
                onChange={(update: [Date | null, Date | null]) => { setDateRange(update); }}
                isClearable={true}
                dateFormat="dd/MM/yyyy"
                placeholderText="dd/mm/aaaa - dd/mm/aaaa"
                className="w-full border rounded p-2"
              />
            </div>
          </div>

          <div className="mb-4">
            <label className="block font-medium mb-1">Selecione as Unidades:</label>
            <div className="flex flex-col gap-1 p-2 border rounded max-h-40 overflow-y-auto">
              {unidades.map((unidade) => (
                <label key={unidade.id} className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    className="defaultCheckbox relative flex h-[20px] min-h-[20px] w-[20px] min-w-[20px] appearance-none items-center justify-center rounded-md border border-gray-300 text-white/0 outline-none transition duration-200 checked:border-none checked:text-white hover:cursor-pointer checked:bg-[#CF4949]"
                    checked={selectedUnidadesExport.includes(unidade.id)}
                    onChange={() => {
                      setSelectedUnidadesExport((prev) =>
                        prev.includes(unidade.id)
                          ? prev.filter((id) => id !== unidade.id)
                          : [...prev, unidade.id]
                      );
                    }}
                  />
                  <span className="text-sm">{unidade.nome}</span>
                </label>
              ))}
            </div>
          </div>

          <div className="mb-4">
            <label className="block font-medium mb-1">Selecione o Tipo de Arquivo:</label>
            <div className="relative">
              <select
                className="w-full border rounded p-2 appearance-none"
                value={fileType}
                onChange={(e) => setFileType(e.target.value as any)}
              >
                <option value=".xlsx">.xlsx</option>
                <option value=".xls">.xls</option>
                <option value=".csv">.csv</option>
              </select>
              <MdArrowDropDown className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none h-6 w-6" />
            </div>
          </div>

          {/* <div className="mb-6">
            <label className="block font-medium mb-1">Enviar por e-mail (opcional):</label>
            <div className="relative">
              <input
                type="email"
                placeholder="email@exemplo.com"
                value={emailParaEnvio}
                onChange={(e) => setEmailParaEnvio(e.target.value)}
                className="w-full border rounded p-2 pl-10"
              />
              <MdEmail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            </div>
          </div> */}

          <div className="flex justify-center items-center gap-2">
            {/* <button
              className="flex-1 mt-2 px-3 py-1 bg-[#CF4949] font-bold text-white transition duration-200 hover:bg-[#B84343] rounded disabled:bg-gray-400"
              onClick={handleSendEmail}
              disabled={isSending || isExporting}
            >
              {isSending ? "Enviando..." : "Enviar"}
            </button> */}
            <button
              className="flex-1 mt-2 px-3 py-1 bg-[#CF4949] font-bold text-white transition duration-200 hover:bg-[#B84343] rounded disabled:bg-gray-400"
              onClick={handleExport}
              disabled={isExporting || isSending}
            >
              {isExporting ? "Baixando..." : "Baixar"}
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
}
